import type React from 'react';

import type { LivenessStateNullable } from '@vlabs/api/luna-api/model/LivenessStateNullable';

import { useEventDetailsGeneralInfoTranslation } from '../i18n';
import st from './shared.module.sass';

interface LivenessRowProps {
  liveness?: LivenessStateNullable;
}

function LivenessRow({ liveness = null }: LivenessRowProps): string | React.JSX.Element {
  const { t } = useEventDetailsGeneralInfoTranslation();

  if (liveness === 0) return t('liveness_0');
  if (liveness === 1) return t('liveness_1');
  if (liveness === 2) return t('liveness_2');
  return (<span className={st.Null}>{t('liveness_null')}</span>);
}

export { LivenessRow };
